import { render, staticRenderFns } from "./DaysRejectedWidget.vue?vue&type=template&id=48ea9949&scoped=true&"
import script from "./DaysRejectedWidget.vue?vue&type=script&lang=js&"
export * from "./DaysRejectedWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ea9949",
  null
  
)

export default component.exports